import { render, staticRenderFns } from "./CreativesDiscrepancyModal.vue?vue&type=template&id=df35fa24&scoped=true&"
import script from "./CreativesDiscrepancyModal.vue?vue&type=script&lang=js&"
export * from "./CreativesDiscrepancyModal.vue?vue&type=script&lang=js&"
import style0 from "./CreativesDiscrepancyModal.vue?vue&type=style&index=0&id=df35fa24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df35fa24",
  null
  
)

export default component.exports